import type { SVGProps } from 'react';

const SvgClassAssistant = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_1234_40757)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#FFF03B'
      />
      <path
        d='M22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22V24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24V22C17.5229 22 22 17.5229 22 12Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0001 6C12.4667 6.00008 12.8998 6.26655 13.1066 6.68608L17.8684 16.2081C18.1749 16.821 17.9281 17.5604 17.3147 17.8668C17.1347 17.9534 16.9477 18 16.761 18C16.3077 17.9999 15.8679 17.7468 15.6545 17.3139L14.3605 14.7273H9.63969L8.34571 17.3139C8.03894 17.9269 7.29803 18.1733 6.68453 17.8668C6.07135 17.5603 5.82525 16.8209 6.13178 16.2081L10.8927 6.68608C11.0994 6.26634 11.5333 6 12.0001 6ZM10.7315 12.5455H13.2687L12.0001 10.011L10.7315 12.5455Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1234_40757'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassAssistant;
